import { Button, Space } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { AttrSelectTableLayout } from "src/business/attribute/attrEdits/components/AttrSelectTableLayout";
import { CatalogsTree } from "src/business/catalog/CatalogsTree";
import { LoaderBox } from "src/components/LoaderBox";
import { MdmDrawer } from "src/components/MdmDrawer";
import { QuerySearch } from "src/components/QuerySearch/QuerySearch";
import { ZSidLabel } from "src/types";

import {
  AttrRecordSelectStore,
  DataAttrRecordSelect,
} from "./AttrRecordSelectStore";

type PropsAttrRecordSelectModal = {
  open: boolean;
  close: () => void;
  catalogId: string;
  labelTemplate?: string | null;
  srcValue: ZSidLabel | ZSidLabel[] | null;
  multi: boolean;
  onOk(value: ZSidLabel | ZSidLabel[] | null): void;
};

export const AttrRecordSelectModal: React.FC<PropsAttrRecordSelectModal> =
  observer((props) => {
    const { open, close, catalogId, srcValue, multi, onOk, labelTemplate } =
      props;
    const store: AttrRecordSelectStore | undefined = React.useMemo(() => {
      if (!open) return undefined;
      return new AttrRecordSelectStore(
        catalogId,
        srcValue,
        multi,
        labelTemplate,
      );
    }, [open]);
    const extra = (
      <Space>
        <Button onClick={close}>Отмена</Button>
        <Button
          type="primary"
          disabled={store?.okDisabled}
          onClick={() => {
            onOk(store?.curValue ?? null);
            close();
          }}
        >
          Выбрать
        </Button>
      </Space>
    );
    return (
      <MdmDrawer
        open={open}
        wide
        onClose={close}
        title={store?.title || "..."}
        extra={extra}
      >
        {!!store && (
          <LoaderBox
            remoteData={store.data}
            drawReady={(data) => <Inner data={data} store={store} />}
          />
        )}
      </MdmDrawer>
    );
  });

type PropsInner = {
  data: DataAttrRecordSelect;
  store: AttrRecordSelectStore;
};

const Inner: React.FC<PropsInner> = observer((props) => {
  const { data, store } = props;
  const { table, columns, tree } = data;
  const onNode = (classifierId?: string, classId?: string) => {
    table.changeFilters({ ...table.filters, classifierId, classId });
  };
  const onTag = () => {
    table.changeFilters({
      ...table.filters,
      classifierId: undefined,
      classId: undefined,
    });
    tree.setSelectedKey(null);
  };
  // Сброс табличных фильтров извне => надо сбросить выбор в дереве
  React.useEffect(() => {
    if (!table.filters?.classifierId && tree.activeNode) {
      tree.setSelectedKey(null);
    }
  }, [table.filters?.classifierId]);
  return (
    <AttrSelectTableLayout
      table={table}
      columns={columns}
      makeOption={store.makeOption}
      leftPart={<CatalogsTree store={tree} onChangeNode={onNode} />}
      activeFilterLabel={tree.activeNode?.name}
      onClearFilter={onTag}
      mainTools={
        <QuerySearch
          value={table.filters?.query}
          onChange={(value) => table.changeSingleFilter("query", value)}
        />
      }
    />
  );
});
